'use strict';

import Toggle from '@borngroup/born-toggle';
// import {callbackOnElements} from '@borngroup/born-utilities';
import {setupVariationListeners} from '../product/variationsUtils';
import {handleCartAdd} from '../product/addToCart';
import {getProductContainer, getProductType} from '../product/productUtils';
import * as progress from '../components/progress';
// import * as lineItem from '../cart/lineItem';

const PRODUCT_TYPE = 'quickadd';

let currentlyActiveQuickAdd;

function _renderQuickAddPanel(productContainer, response) {
    let quickAddPanel = productContainer.querySelector('[data-quickadd-component="panel"]');

    quickAddPanel.textContent = '';
    quickAddPanel.insertAdjacentHTML('afterbegin', response.renderedTemplate);

    //Ensures there's a wait before HTML is inserted.
    document.body.offsetWidth;

    quickAddPanel.classList.add('set--ready');

    setupVariationListeners(quickAddPanel);
}

// function _renderQuickAddActions(currentContainer, response) {
//     if (!currentContainer.querySelector('[data-quickadd-component="actions"]')) {
//         currentContainer.insertAdjacentHTML('beforeend', response.renderedActionsTemplate);
//     }
// }

function _handleQuickAddSuccess(currentTrigger, response) {
    let productContainer = getProductContainer(currentTrigger);

    progress.hideLoader();

    if (response.product.readyToOrder) {
        // _renderQuickAddActions(_getQuickAddContainer(currentTrigger), response);

        handleCartAdd(productContainer, response.product);
    } else {
        _renderQuickAddPanel(productContainer, response);
    }
}

// function _getQuickAddContainer(el) {
//     return el.closest('[data-quickadd]');
// }

function _onAfterAttributeSelect() {
    $('body').on('product:afterAttributeSelect.quickAdd', function(evt, response) {
        if (getProductType(response.container) === PRODUCT_TYPE && response.data.product.readyToOrder) {
            handleCartAdd(response.container, response.data.product);
        }
    });
}

function _onAfterAddToCart() {
    $('body').on('product:afterAddToCart.quickAdd', function() {
        if (currentlyActiveQuickAdd) {
            // let quickAddContainer = _getQuickAddContainer(currentlyActiveQuickAdd),
            //     quickAddActions = quickAddContainer.querySelector('[data-quickadd-component="actions"]');

            // console.log(data);

            // if (quickAddActions) {
            //     quickAddActions.setAttribute('data-cart-line-item', data.response.pliUUID);

            //     lineItem.init(quickAddActions);

            //     quickAddContainer.classList.add('set--added-to-cart');
            // }

            currentlyActiveQuickAdd.toggle.unset();
        }
    });
}

export function requestQuickAdd(quickAddURL, currentTrigger) {
    progress.showLoader(currentTrigger);

    $.ajax(quickAddURL, {
        success: _handleQuickAddSuccess.bind(this, currentTrigger)
    });
}

export function setupQuickAddListeners() {
    return new Toggle({
        triggers: '[data-quickadd-trigger]',
        target: '[data-quickadd-component="panel"]',
        parent: '[data-product-container]',
        dataAttribute: 'data-quickadd-trigger',
        activeClass: 'set--quickadd-active',
        targetFocus: true,
        focusTrap: true,
        beforeSet: function(currentTrigger) {
            currentlyActiveQuickAdd = currentTrigger;

            requestQuickAdd(currentTrigger.href || currentTrigger.getAttribute('data-url'), currentTrigger);

            return true;
        },
        afterUnset: function(currentTrigger) {
            currentlyActiveQuickAdd = undefined;

            currentTrigger.toggle.targetEl.classList.remove('set--ready');
        }
    });
}

export function init() {
    setupQuickAddListeners();
    _onAfterAttributeSelect();
    _onAfterAddToCart();
}
